import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-store';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  buildVersion: string;

  constructor(
    public router: Router,
    public ls: LocalStorageService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    const apiUrl = `${environment.url}version`;

    this.http.get(apiUrl, { responseType: 'text' }).subscribe({
      next: (response: string) => {
        console.log('Response:', response);
        this.buildVersion = response.trim();
      },
      error: (error) => {
        console.error('Error fetching project version:', error);
      }
    });
  }
}
